<template>
  <div class="adesao">
      <iframe src="https://formandos.stillos.com.br" class="iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'gallery',
}
</script>


<style scoped lang="scss">
.adesao{
    width: 1415px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    .iframe {
        transform: scale(1.3);
        margin-left: 151px;
        margin-top: 161px;
        width: 1024PX;
        height: 100%;
        border: none;
    }
}
</style>